import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var CodeBlockSvg = function CodeBlockSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m9.188 19.903 7-16.104-1.376-.598-7 16.104zM5.494 6.866l1.06 1.061-4.073 4.074 4.074 4.074-1.061 1.06-5.135-5.134zM21.53 12l-4.074-4.073 1.06-1.06L23.651 12l-5.135 5.135-1.06-1.061z"
  }));
};
export var CodeBlock = function CodeBlock(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: CodeBlockSvg
  }));
};